import utils from "./index.js"
export default {
    //数组叉乘
    // let aaa=[{name:'1',value:'01'},{name:'2',value:'02'},{name:'3',value:'03'},{name:'4',value:'04'}]
    // let bbb=[4,5,6,7]
    // let ccc-[8,9,0]
    // let ddd=[aaa,bbb,ccc]
    // let ggg=[]
    // recursionSub (ggg, ddd.length, ddd, 0, -1);
    forkMultiply(list, count, array, ind, start, indexs) {
        start++;
        if (start > count - 1) {
            return null;
        }
        if (start == 0) {
            indexs = [];
        }
        for (indexs[start] = 0; indexs[start] < array[start].length; indexs[start]++) {
            this.forkMultiply(list, count, array, 0, start, indexs);
            if (start == count - 1) {
                let temp = [];
                for (let i = count - 1; i >= 0; i--) {
                    temp[start - i] = array[start - i][indexs[start - i]];
                }
                list.push(temp);
            }
        }
        return list;
    },
    //数组叉乘 data: [[2,3,4],["1","a",{name:"aa"}]]
    getForkMultiply(data) {
        let list = []
        if (utils.getDataType(data) === "array") {
            this.forkMultiply(list, data.length, data, 0, -1)
        }
        return list
    },
    //获取传递过来数据的所有没子节点的节点。
    getChildrenNode(listData) {
        let self = this;
        let nodes = [];
        listData.forEach(item => {
            if (item.children && Array.isArray(item.children) && item.children.length > 0) {
                const cNodes = self.getChildrenNode(item.children);
                if (nodes.length > 0 && cNodes.length > 0) {
                    nodes = nodes.concat(cNodes);
                } else {
                    nodes = cNodes;
                }
            } else {
                nodes.push(item);
            }
        });
        return nodes;
    },
    getCheckTabelSelect(self, tableName, selectName) {
        tableName = tableName || "listTable"
        let list = self.$refs[tableName].getSelected();
        if (list.length == 0) {
            utils.tips.pleaseSelect()
        } else {
            selectName = selectName || "tabelSelect"
            self[selectName] = list
            return list
        }
        return false
    },
    //获取，并检验表格只能选择一条数据
    getCheckTabelSelectOne(self, tableName, selectName) {
        tableName = tableName || "listTable"
        let list = self.$refs[tableName].getSelected();
        if (list.length == 0) {
            utils.tips.pleaseSelect()
        } else if (list.length > 1) {
            utils.tips.pleaseSelectOne()
        } else {
            selectName = selectName || "tabelSelect"
            self[selectName] = list[0]
            return list[0]
        }
        return false
    },
    //表格单个删除校验
    deleteOneCheck(self, tableName, selectName) {
        tableName = tableName || "listTable"
        let list = self.$refs[tableName].getSelected();
        if (list.length == 0) {
            utils.tips.pleaseSelect()
        } else if (list.length > 1) {
            utils.tips.pleaseSelectOne()
        } else {
            selectName = selectName || "tabelSelect"
            self[selectName] = list[0]
            return utils.tips.isNotDelete()
        }
        return new Promise(function (resolve, reject) { reject("cancel") })
    },
    //表格批量删除校验
    deleteCheck(self, tableName, selectName) {
        tableName = tableName || "listTable"
        let list = self.$refs[tableName].getSelected();
        if (list.length == 0) {
            utils.tips.pleaseSelect()
        } else {
            selectName = selectName || "tabelSelect"
            self[selectName] = list
            if (self.packages) { //套餐管理删除按钮提示专用
                return utils.tips.isPackageDelete()
            } else if(self.userManage){ //包含非荣耀用户类型删除按钮提示
                return utils.tips.isNotDeleteuserMana()
            } else {
                return utils.tips.isNotDelete()
            }
        }
        return new Promise(function (resolve, reject) { reject("cancel") })
    },
    /**
    * 数字保留几位小数点，没有四舍五入
    * numb 需要处理的数字
    * precision 保留小数点位数
    * isSupplement 不足补零
    */
    fixed(numb, precision, isSupplement) {
        precision = Number(precision) || -1
        let str = numb + '',
            i = str.indexOf('.');
        if (isSupplement) {
            if (i > -1) {
                str = str + '0'.repeat(Math.abs(precision))
            } else {
                str = str + '.' + '0'.repeat(Math.abs(precision))
            }
        }
        if (i > -1) {
            str = str.substring(0, i + 1 + precision);
        }

        return str;
    },
    /**小数 数字四舍五入，向上、向下取数
     * numb 需要处理的数字
     * precision 保留小数点位数
     * fixedType 处理类型1、四舍五入；2、向下取；3、向上取
     * isSupplement 不足补零.默认补
     */
    toFixed(numb, precision, fixedType, isSupplement) {
        let str = numb + '',
            strA = this.fixed(numb, Number(precision) + 1, true),
            bit = strA.lastIndexOf("."),
            intStr = strA.replace(".", ""),
            strB = intStr.slice(0, intStr.length - 1),
            newStrB=strB,
            lastNumb = intStr.slice(-1);
        if (bit === -1) return numb
        fixedType = fixedType || 1
        // 1.四舍五入、2.向下取、3.向上取
        if (fixedType == '1') {
            if (lastNumb > 4) {
                newStrB = utils.addition(strB, 1)
            }
        } else if (fixedType == '3') {
            if (lastNumb > 0) {
                newStrB = utils.addition(strB, 1)
            }
        }
        str = newStrB
        if (bit > -1) {
            bit+=newStrB.length-strB.length
            str = str.slice(0, bit) + "." + str.slice(bit)
            //去掉多余小数点
            str=str.replace(/\.$/,"")
        }
        if (isSupplement === false || isSupplement === "false") {
            //去掉小数点后面多余的0
            str = str.replace(/(?:\.0*|(\.\d+?)0+)$/, "$1")
        }
        return str
    },
    //table自定义渲染数字类型。可以带小数点
    getInputNumber(value, precision, max, min) {
        if (!value && value != '0') { return null }
        max = max || 100000000
        min = min || 0
        if (utils.isObject(value)) {
            precision = value.precision
            max = value.max || 100000000
            min = value.min || 0
        }
        value = Number(value)
        if (isNaN(value)) {
            value = 0
        }
        if (precision) value = Number(value).toFixed(precision)
        if (value > max) {
            value = max
        } else if (value < min) {
            value = min
        }
        return value
    },
    //获取金额数字，补两位小数点
    getPriceNumber(value, defValue) {
        let self = this;
        return self.getInputNumber(value, 2) || defValue || null
    },
    /**
     * 获取修改履历详情
     * @param {*} data 新数据
     * @param {*} oData 旧数据
     * @param {*} columns 列设置
     * @param {*} primaryKey 主键字段
     * @param {*} operateDesc 操作详情字段
     * @param {*} cacheObj 缓存对象，如果列中有下拉框的值，需要将value转为label
     */
    getChangeDetails(data, oData, columns, primaryKey, operateDesc, cacheObj) {
        //规则为[建议零售价: 50.00 --> 51;售价下限: 12-->11]
        let oldCache = {};
        //以主键key缓存所有原始数据
        oData.filter(row => {
            oldCache[row[primaryKey]] = row
        })
        //遍历所有修改的数据，进行对比
        data.filter(row => {
            let changeStr = ""
            columns.filter(col => {
                let oldRow = oldCache[row[primaryKey]]
                if (oldRow[col.key] != row[col.key]) {
                    let oldStr = oldRow[col.key],
                        newStr = row[col.key];
                    //如果列中有下拉框的值，把value转为label
                    if (col.edit && col.type == "dropdown") {
                        //获取缓存中对象
                        let editCfg = col.editCfg,
                            oldStrObj = cacheObj[oldRow[col.key]],
                            newStrObj = cacheObj[row[col.key]];
                        //从对象中取出label值
                        oldStr = oldStrObj ? oldStrObj[editCfg.label] : oldStr
                        newStr = newStrObj ? newStrObj[editCfg.label] : newStr
                    }
                    changeStr += col.title + ': ' + oldStr + ' --> ' + newStr + ';'
                }
            })
            row[operateDesc] = changeStr
        })
    },
    getCacheObj(dataList, key) {
        let cacheObj = {};
        dataList = dataList || []
        dataList.filter(item => {
            cacheObj[item[key]] = item
        })
        return cacheObj
    },
    /**
     * 获取修改履历详情
     * @param {*} data 新数据
     * @param {*} oData 旧数据
     * @param {*} columns 列设置
     * @param {*} primaryKey 主键字段
     * @param {*} operateDesc 操作详情字段
     * @param {*} dropDataObj 下拉数据集合，如果列中有下拉框的值，需要将value转为label
     */
    getObjChangeDetails(data, oData, columns, primaryKey, operateDesc, dropDataObj) {
        //规则为[建议零售价: 50.00 --> 51;售价下限: 12-->11]
        primaryKey = primaryKey || "key"
        let changeStr = ""
        for (let i = 0; i < columns.length; i++) {
            const col = columns[i];
            let keyStr = col[primaryKey],
                newStr = utils.isEmptyObject(data) ? "" : eval("data." + keyStr),
                oldStr = utils.isEmptyObject(oData) ? "" : eval("oData." + keyStr);
            //处理数组情况的变化
            if (col.type == "Array") {
                if (col.columns) {
                    let arrStr = ""
                    let j = 0
                    for (; j < oldStr.length; j++) {
                        if (oldStr[j]) {
                            let str = this.getObjChangeDetails(newStr[j], oldStr[j], col.columns, primaryKey, "", dropDataObj)
                            if (str != "") arrStr += j + 1 + ":" + str
                        } else {
                            arrStr += j + 1 + ":删除"
                        }
                    }
                    if (newStr.length > j) {
                        for (let k = j; k < newStr.length; k++) {
                            let str = this.getObjChangeDetails(newStr[k], {}, col.columns, primaryKey, "", dropDataObj)
                            arrStr += "新增" + k + 1 + ":" + str
                        }
                    }
                    changeStr += col.title + ': [' + arrStr + '];'
                    continue
                } else {
                    newStr = newStr.toString()
                    oldStr = oldStr.toString()
                }
            }
            if (newStr !== oldStr) {
                //如果列中有下拉框、单选框的值，把value转为label
                if (col.edit) {
                    //获取缓存中对象
                    let editCfg = col.editCfg || {
                        key: "key",
                        label: "label"
                    },
                        cacheObj = this.getCacheObj(dropDataObj[keyStr], editCfg.key),
                        oldStrObj = cacheObj[oldStr],
                        newStrObj = cacheObj[newStr];
                    //从对象中取出label值
                    oldStr = oldStrObj ? oldStrObj[editCfg.label] : oldStr
                    newStr = newStrObj ? newStrObj[editCfg.label] : newStr
                }
                changeStr += col.title + ': ' + oldStr + ' --> ' + newStr + ';'
            }
        }
        if (operateDesc) data[operateDesc] = changeStr
        return changeStr
    },
    /**
     * 等级管理修改履历详情
     * @param {*} obj 旧数据
     * @param {*} nObj 新数据
     */
    getChangeRules(obj, nObj) {
        let self = this, strList = [];
        for (let j in nObj) {
            let str = '';
            if (j == 'gradePrefix' && obj.gradePrefix != nObj.gradePrefix) {
                str = '会员等级：' + obj.gradePrefix + ' --> ' + nObj.gradePrefix;
            } else if (j == 'gradeName' && obj.gradeName != nObj.gradeName) {
                str = '等级名称：' + obj.gradeName + ' --> ' + nObj.gradeName;
            } else if (j == 'requiredGrowth' && obj.requiredGrowth != nObj.requiredGrowth) {
                str = '所需成长值：' + obj.requiredGrowth + ' --> ' + nObj.requiredGrowth;
            } else if (j == 'upgradeRewardPoints' && obj.upgradeRewardPoints != nObj.upgradeRewardPoints) {
                str = '升级送积分：' + obj.upgradeRewardPoints + ' --> ' + nObj.upgradeRewardPoints;
            } else if (j == 'upgradeRewardGrowth' && obj.upgradeRewardGrowth != nObj.upgradeRewardGrowth) {
                str = '升级送成长值：' + obj.upgradeRewardGrowth + ' --> ' + nObj.upgradeRewardGrowth;
            } else if (j == 'pointsFeedbackRate' && obj.pointsFeedbackRate != nObj.pointsFeedbackRate) {
                str = '积分回馈权益：' + obj.pointsFeedbackRate + ' --> ' + nObj.pointsFeedbackRate;
            } else if (j == 'growthFeedbackRate' && obj.growthFeedbackRate != nObj.growthFeedbackRate) {
                str = '成长值回馈权益：' + obj.growthFeedbackRate + ' --> ' + nObj.growthFeedbackRate;
            } else if (j == 'discount' && obj.discount != nObj.discount) {
                str = '折扣权益：' + obj.discount + ' --> ' + nObj.discount;
            } else if(j == 'cardBackgroundUrl' && JSON.parse(obj.cardBackgroundUrl).fileName != nObj.cardBackgroundUrl){
                str = '会员卡背景：' + JSON.parse(obj.cardBackgroundUrl).fileName + ' --> ' + nObj.cardBackgroundUrl;
                str = nObj.cardBackgroundUrl==undefined?"":str;
            }else if(j == 'gradeIconUrl' && JSON.parse(obj.gradeIconUrl).fileName != nObj.gradeIconUrl){
                str = '背景图标：' + JSON.parse(obj.gradeIconUrl).fileName + ' --> ' + nObj.gradeIconUrl;
                str = nObj.gradeIconUrl==undefined?"":str;
            }else if(j == 'avatarUrl'){ //会员头像非必填
                obj.avatarUrl=obj.avatarUrl==null?[]:JSON.parse(obj.avatarUrl).fileName
                if(obj.avatarUrl!= nObj.avatarUrl){
                    str = '会员头像：' + obj.avatarUrl + ' --> ' + nObj.avatarUrl;
                    str = nObj.avatarUrl==undefined?"":str;
                }
            }
            if (str) { strList.push(str) }
        }
        strList = strList.join(",")
        return strList
    }

}


// WEBPACK FOOTER //
// ./src/utils/edit.js